import { Directive, EventEmitter, Input, Output } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'tur-footer-buttons' })
export class FooterButtonsDirective {
  @Input() public icon: string;
  @Input() public disabled: string;
  @Input() public title: string;
  @Input() public iconSet: 'material' | 'porsche';
  @Output() public buttonClick: EventEmitter<Event> = new EventEmitter<Event>();

  public handedInFunction(event: Event): void {
    if (!this.disabled) {
      this.buttonClick.emit(event);
    }
  }
}
